// src/utils/constants.ts

// Global z-index scale used across StoryCore. Keep numbers sparse so we
// have room to insert layers later without churn.
export const Z = {
  BACKGROUND: 0,          // static background layer
  VIDEO: 150,             // background video plane inside a section (above BLUR, below OVERLAY)
  BLUR: 100,              // canvas blur/filters above BACKGROUND, below VIDEO
  OVERLAY: 200,           // gradients/fades/vignettes above bg/blur
  IMAGE_OVERLAYS: 300,    // decorative images / logos above overlay
  CONTENT: 500,           // main text/content layer
  CAPTIONS: 800,          // captions/subtitles overlay
  PROGRESS: 900,          // scroll/progress bar
  WAKE: 950,              // wake zone layer (sits under HUD, above progress)
  HUD: 1000,              // HUD / controls on top of everything
} as const;

// Temporary backwards-compat shim so legacy imports keep working.
// TODO: migrate callsites to `Z.*` and then remove this export.
// export const hudZ = {
//  video: Z.VIDEO,
//  blur: Z.BLUR,
//  overlay: Z.OVERLAY,
//  captions: Z.CAPTIONS,
//  hud: Z.HUD,
// } as const;

// Minimum intersection ratio for a section to be considered "visible enough"
// Used by observerSections.ts and related activation logic.
export const VISIBILITY_THRESHOLD = 0.4;

// LocalStorage keys
export const LS_KEYS = {
  captionsEnabled: "storycore-captions-enabled", // "true" or "false"
  audioMuted: "storycore-audio-muted",           // "true" or "false"
  firstReelSeen: "storycore-first-reel-seen",    // "true" or absent
} as const;